import { MultiSelectOption } from "./IMultiSelectOption";

/**
 * A utility file for when you want to treat MultiSelects as a nullable single
 * item selector without repeating the same array logic.
 *
 * Intended for use with getOnSingleSelectionChange()
 *
 * Allows you to useState<MultiSelectOption>() instead of
 * useState<MultiSelectOption[]>()
 *
 * Example use:
 *
 * const [thing, setSelectedThing] = useState<MultiSelectOption | null>(null);
 *
 * <Multiselect
 *   {...snippedProps}
 *   maxSelections={1} //Not required to limit to 1, but intended
 *   selectedItems={getSingleSelectedItemAsArray(thing)}
 *   setSelectedItems={getOnSingleSelectionChange(setSelectedThing)}
 * />
 *
 */

export function getSingleSelectedItemAsArray(item: MultiSelectOption | null) {
  return item ? [item] : [];
}
